import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    installation_forms: [],
    installation_forms_loading: false
  };
};

const state = getDefaultState();

const getters = {
  getInstallationForms: state => {
    return state.installation_forms;
  },
  getInstallationFormsLoading: state => {
    return state.installation_forms_loading;
  }
};

const actions = {
  fetchInstallationForms({ commit, rootGetters }, payload) {
    commit("setInstallationFormsLoading", true);

    const searchValue =
      payload.search != null && payload.search.trim().length > 0
        ? payload.search.replace(/\\/g, "\\\\").replace(/"/g, '\\"')
        : null;

    const statusValue =
      Array.isArray(payload.status) && payload.status.length > 0
        ? `[${payload.status.map(status => '"' + status + '"').join(",")}]`
        : null;

    const data = {
      query: `
        query {
          allDeviceInstallations (
            limit: ${payload.limit},
            offset: ${payload.offset != null ? payload.offset : null},
            search: ${searchValue != null ? '"' + searchValue + '"' : null},
            status: ${statusValue},
            orderBy: ${payload.order_by != null ? '"' + payload.order_by + '"' : null
        }
          ) {
            id
            imei
            notes
            user {
              availableName
            }
            installationType
            billingInfoType
            vehicle {
              licensePlate
              ownerName
              make
              model
            }
            status
            connectionStatus
            updatedAt
            createdAt
          }
        }
      `
    };

    axios
      .post(rootGetters.getWebAppGraphQlUrl, data, {
        headers: {
          Authorization: `Token token=${rootGetters.getUserToken}`
        }
      })
      .then(res => {
        if (res.data.errors !== undefined && res.data.errors.length > 0) {
          alert(res.data.errors[0].message);
          console.log(res);
        } else {
          commit(
            "setInstallationForms",
            res.data.data.allDeviceInstallations.map(install => {
              return {
                id: install.id,
                imei: install.imei,
                user: install.user == null ? "" : install.user.availableName,
                notes: install.notes,
                installation_type: install.installationType,
                make: install.vehicle == null ? "" : install.vehicle.make,
                model: install.vehicle == null ? "" : install.vehicle.model,
                license:
                  install.vehicle == null ? "" : install.vehicle.licensePlate,
                status: install.status,
                billing_info_type: install.billingInfoType,
                customer:
                  install.vehicle != null ? install.vehicle.ownerName : "",
                connection_status: install.connectionStatus,
                updated_at: install.updatedAt,
                created_at: install.createdAt,
                _rowVariant:
                  install.status == "completed"
                    ? "success"
                    : install.status == "pending" &&
                      install.connectionStatus == "ok"
                      ? "info"
                      : install.status == "pending"
                        ? "danger"
                        : null
              };
            })
          );
        }
      })
      .catch(err => {
        alert(err);
        console.error(err);
      })
      .finally(() => {
        commit("setInstallationFormsLoading", false);
      });
  }
};

const mutations = {
  setInstallationForms(state, value) {
    state.installation_forms = value;
  },
  setInstallationFormsLoading(state, value) {
    state.installation_forms_loading = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
